import {
  PAGE_PROCESSLIST_INITIALIZE,
  PAGE_PROCESSLIST_SEARCHQUERY,
  PAGE_PROCESSLIST_FILTERCATEGORY,
  PAGE_PROCESSLIST_FILTERFAVORITES,
  PAGE_PROCESSLIST_RECEIVE
} from '../../actions/page/ProcessList';
import map from 'lodash/map';
import uniq from 'lodash/uniq';

export default function ProcessList(
  state = {
    loading: true
  },
  action
) {
  switch (action.type) {
    case PAGE_PROCESSLIST_INITIALIZE:
      const filters = [
        { value: 'favorites', name: 'Favorite Templates' },
        { value: 'all', name: 'All Templates' }
      ];

      return {
        loading: true,
        filters,
        filterByFavorites: false,
        searchValue: '',
        categories: []
      };

    case PAGE_PROCESSLIST_RECEIVE:
      const categories = map(action.processes || [], item => {
        return item.category || 'uncategorized';
      });

      return Object.assign({}, state, {
        categories: uniq(categories),
        loading: false
      });

    case PAGE_PROCESSLIST_FILTERFAVORITES:
      return Object.assign({}, state, {
        filterByFavorites: !state.filterByFavorites
      });

    case PAGE_PROCESSLIST_FILTERCATEGORY:
      return Object.assign({}, state, {
        categoryFilter: action.category
      });

    case PAGE_PROCESSLIST_SEARCHQUERY:
      return Object.assign({}, state, {
        searchValue: action.query
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/ProcessList.js